import { Suspense, lazy } from 'react';
import type { SlotEntry } from '@saas/ui';

/**
 * 画面の差し込み口（`@saas/ui` の Slot）に telephony が出すもの。登録は apps/web/src/app/slots.ts（組み立て）だけが行う。
 *
 * | id | スロット | subjectType | 出すもの | context |
 * |---|---|---|---|---|
 * | telephony.lead-dial | record.actions | lead | 見込み客の電話番号への「発信」（SFA 段階 5 §9.4。発信の意図を残して originate / tel:） | `lead`（phone を読む） |
 * | telephony.conversation-dial | conversation.actions | user / customer / contact / lead / deal | 会話の見出しの「電話」（03 §11.4 #5。DM の相手の内線・直通、レコード会話の相手の番号。GET /telephony/dial-targets） | — |
 *
 * 番号が無ければ何も出さない。電話連携が無効・発信の権限が無い人には DialButton が tel: のリンクに落ちる（会話の「電話」は出さない）
 */
const DialButton = lazy(() => import('./components/DialButton.js').then((m) => ({ default: m.DialButton })));
const ConversationDialButton = lazy(() => import('./components/ConversationDialButton.js').then((m) => ({ default: m.ConversationDialButton })));

export const telephonySlots: SlotEntry[] = [
  {
    id: 'telephony.lead-dial',
    module: 'telephony',
    slot: 'record.actions',
    subjectTypes: ['lead'],
    order: 30,
    Component: ({ subjectId, context }) => {
      const phone = (context?.lead as { phone?: string | null } | undefined)?.phone;
      if (!phone || !subjectId) return null;
      return (
        <Suspense fallback={null}>
          <DialButton number={phone} subjectType="lead" subjectId={subjectId} label={`発信 ${phone}`} variant="secondary" />
        </Suspense>
      );
    },
  },
  {
    // gap-comms（03 §11.4 #5）: チャット・会話ページの見出しから相手に電話をかける。掛け先の判定（読める相手・番号）はサーバ
    id: 'telephony.conversation-dial',
    module: 'telephony',
    slot: 'conversation.actions',
    subjectTypes: ['user', 'customer', 'contact', 'lead', 'deal'],
    permission: ['telephony.call.originate'],
    order: 30,
    Component: (props) =>
      props.subjectId ? (
        <Suspense fallback={null}>
          <ConversationDialButton {...props} />
        </Suspense>
      ) : null,
  },
];
